import isInEditSeriesInstanceMode from './isInEditSeriesInstanceMode';
import { getComposeEvent, getOriginalEvent } from 'owa-calendar-compose-store-manager';
import { isEventAMeeting, isMeetingOnCalendarSharedWithMe } from 'owa-calendar-event-capabilities';

export default function canChangeCalendar(formId: string): boolean {
    const event = getComposeEvent(formId);
    const originalEvent = getOriginalEvent(formId);

    if (!event.ItemId) {
        // If it is a new event, then you can change calendars
        return true;
    }

    if (event.IsDraft) {
        // If it is a draft, then the event is not sent yet, so we can change calendars
        return true;
    }

    if (isEventAMeeting(originalEvent)) {
        // If the originalEvent is a meeting (i.e. you are editing a meeting, not editing an appointment), then we don't let u change calendars.
        // This is because meeting tracking flows don't work in secondary calendars and we discourage it.
        return false;
    }

    if (isInEditSeriesInstanceMode(event)) {
        // If event is instance of series, then don't allow switching calendars.
        // We do not want instance to be in a different calendar than the master.
        return false;
    }

    if (event.CalendarItemType == 'ThisAndFollowingInstancesMaster') {
        return false;
    }

    if (isMeetingOnCalendarSharedWithMe(originalEvent)) {
        // If event is on a shared calendar, then don't allow switching calendars.
        return false;
    }

    return true;
}
